/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CreateTagRequestToJSON, CreateTagResponseFromJSON, ListTagsResponseFromJSON, UpdateTagRequestToJSON, UpdateTagResponseFromJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * List all tags
     */
    v1GetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListTagsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List all tags
     */
    v1Get(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1GetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new tag
     */
    v1PostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/v1`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateTagRequestToJSON(requestParameters['createTagRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateTagResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a new tag
     */
    v1Post() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.v1PostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete a tag
     */
    v1TagIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['tagId'] == null) {
                throw new runtime.RequiredError('tagId', 'Required parameter "tagId" was null or undefined when calling v1TagIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/v1/{tagId}`;
            urlPath = urlPath.replace(`{${"tagId"}}`, encodeURIComponent(String(requestParameters['tagId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a tag
     */
    v1TagIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.v1TagIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update a tag
     */
    v1TagIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['tagId'] == null) {
                throw new runtime.RequiredError('tagId', 'Required parameter "tagId" was null or undefined when calling v1TagIdPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/v1/{tagId}`;
            urlPath = urlPath.replace(`{${"tagId"}}`, encodeURIComponent(String(requestParameters['tagId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateTagRequestToJSON(requestParameters['updateTagRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTagResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update a tag
     */
    v1TagIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.v1TagIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
